import React from "react";
import PropTypes from "prop-types";
import ActivityLogContainer from "./ActivityLogContainer";

const ActivityLog = ({ showSaveNotificationMessage }) => {
  return <ActivityLogContainer showSaveNotificationMessage={showSaveNotificationMessage} />;
};

ActivityLog.propTypes = {
  showSaveNotificationMessage: PropTypes.func.isRequired,
};

export default ActivityLog;
